import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../styles/CorAdmin.css";
import axios from 'axios';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GridLoader } from 'react-spinners';
import ReactDOM from 'react-dom';

function Admin() {
  const navigate = useNavigate();
  const [admins, setAdmins] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showAddress, setShowAddress] = useState(false);
  const [selectedPU, setSelectedPU] = useState({});
  const [showResetModal, setShowResetModal] = useState(false);
  const [resetUser, setResetUser] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 1;

  const baseURL = sessionStorage.getItem('baseURL');

  const navigateToDashboard = () => navigate('/dashboard');

  const fetchDetails = async () => {
    try {
      const addrResp = await axios.get(baseURL + "pu/getGroupIds");
      let addresses = addrResp.data;
      let data = {};
      for (var j in addresses) {
        const addr = addresses[j];
        data[addr['production_unit_name']] = { address: addr['address'], users: [] };
      }
      const response = await axios.get(baseURL + "auth/users");
      const resp = response.data;

      for (var i in resp) {
        const user = resp[i];
        data[user.group_id]['users'].push([
          user.is_pm ? 'Production QA' : 'Production Data Entry',
          user.username,
          user.name,
          user.email,
          user.device_registered,   // ← index [4], true/false
        ]);
      }

      let formattedData = [];
      for (i in data) {
        data[i]['name'] = i;
        formattedData.push(data[i]);
      }
      setAdmins(formattedData);
      document.getElementById('loading').hidden = true;
    } catch (error) {
      console.error("Error fetching details:", error);
    }
  };

  useEffect(() => {
    if (sessionStorage.getItem('isLoggedIn') !== "true") {
      navigate('/');
    } else if (sessionStorage.getItem('isAdmin') !== "true") {
      navigate('/dashboard');
    }
    fetchDetails();
  }, [navigate]);

  // Pagination
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentAdmins = admins.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(admins.length / rowsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((p) => p + 1);
  };
  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage((p) => p - 1);
  };

  function showToast(message, type = "success") {
    const toast = document.createElement("div");
    toast.innerText = message;
    const bg =
      type === "error" ? "#C0392B" :
        type === "warning" ? "#e67e22" :
          "#1a6b3c";
    Object.assign(toast.style, {
      position: "fixed",
      top: "20px",
      right: "20px",
      background: bg,
      color: "#fff",
      padding: "12px 20px",
      borderRadius: "8px",
      boxShadow: "0 6px 20px rgba(0,0,0,0.18)",
      zIndex: 9999,
      opacity: "0",
      fontSize: "0.92rem",
      fontFamily: "'Source Sans 3', system-ui, sans-serif",
      fontWeight: "600",
      letterSpacing: "0.01em",
      transition: "opacity 0.3s ease",
    });
    document.body.appendChild(toast);
    requestAnimationFrame(() => (toast.style.opacity = "1"));
    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => toast.remove(), 300);
    }, 3500);
  }

  const handleEditUser = (user, admin) => {
    sessionStorage.setItem('userData', JSON.stringify(user));
    sessionStorage.setItem('productionUnit', admin.name);
    navigate('/update-users');
  };

  const handleDeleteUser = (user) => {
    axios
      .get(baseURL + `auth/deleteUser/${user[1]}`, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      })
      .then(() => {
        showToast("User deleted successfully");
        fetchDetails();
        setShowDeleteModal(false);
      })
      .catch((error) => {
        console.error("Delete User failed", error);
        showToast("Error deleting user. Please try again.", "error");
      });
  };

  // Step 1 — opens the confirmation modal
  const handleResetDeviceClick = (user) => {
    setResetUser(user);
    setShowResetModal(true);
  };

  // Step 2 — called when admin confirms inside modal
  const confirmResetDevice = () => {
    const username = resetUser[1];
    document.getElementById('loading').hidden = false;
    setShowResetModal(false);

    axios
      .post(baseURL + `auth/resetDevice/${username}`, {}, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      })
      .then(() => {
        showToast(`Device reset successfully for ${username}`);
        fetchDetails();
      })
      .catch((error) => {
        console.error("Reset Device failed", error);
        showToast("Error resetting device. Please try again.", "error");
      })
      .finally(() => {
        document.getElementById('loading').hidden = true;
      });
  };

  const updateAddress = () => {
    if (!selectedPU.address.trim()) {
      showToast("Address cannot be empty", "error");
      return;
    }
    const formData = new FormData();
    formData.append("productionUnitName", selectedPU.name);
    formData.append("address", selectedPU.address);
    try {
      document.getElementById("loading").hidden = false;
      axios.post(baseURL + "pu/updatePU", formData, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem("token")}` },
      }).then(() => {
        document.getElementById("loading").hidden = true;
        showToast("Production unit updated successfully");
        fetchDetails();
        setShowAddress(false);
      });
    } catch (err) {
      console.error("Update Production Unit failed", err);
      showToast("Error updating production unit. Please try again.", "error");
    } finally {
      document.getElementById("loading").hidden = true;
    }
  };

  const handleAddressChange = (e) =>
    setSelectedPU((prev) => ({ ...prev, address: e.target.value }));

  return (
    <div className="corAdmin">

      {/* ── Header ── */}
      <div className="dashboard-header">
        <button onClick={navigateToDashboard} className="action-button">
          ← Back
        </button>
        {/* Optional: add a page label or logo here */}
        <span style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: "1.1rem", opacity: 0.85 }}>
          Admin Panel
        </span>
      </div>


      {/* ── Delete Modal ── */}
      {showDeleteModal && ReactDOM.createPortal(
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Confirm Deletion</h2>
            <p>Are you sure you want to permanently delete this user? This action cannot be undone.</p>
            <div className="action-buttons">
              <button className="no" onClick={() => setShowDeleteModal(false)}>Cancel</button>
              <button className="yes" onClick={() => handleDeleteUser(selectedUser)}>Delete</button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* ── Reset Device Modal ── */}
      {showResetModal && resetUser && ReactDOM.createPortal(
        <div className="modal-overlay">
          <div className="modal-content reset-device-modal">
            <div className="reset-modal-icon">🔒</div>
            <h2>Reset Device</h2>
            <div className="reset-modal-user-info">
              <span className="reset-modal-label">Username</span>
              <span className="reset-modal-value">{resetUser[1]}</span>
              <span className="reset-modal-label">Name</span>
              <span className="reset-modal-value">{resetUser[2]}</span>
              <span className="reset-modal-label">Role</span>
              <span className="reset-modal-value">{resetUser[0]}</span>
            </div>
            <p className="reset-modal-desc">
              This will remove the registered device for this user.
              They will be able to register a new device on their next login.
            </p>
            <div className="action-buttons">
              <button className="no" onClick={() => { setShowResetModal(false); setResetUser(null); }}>
                Cancel
              </button>
              <button className="reset-confirm-btn" onClick={confirmResetDevice}>
                Reset Device
              </button>
            </div>
          </div>
        </div>,
        document.body
      )}

      {/* ── Main Content ── */}
      <div className="admin-container">
        <div className="admin-list-container">
          <h1 className="admin-title">Production Unit Management</h1>

          <div className="admin-table-container">
            <table className="admin-table">
              <thead>
                <tr>
                  <th width="15%">Production Unit</th>
                  <th width="18%">Address</th>
                  {/* <th width="12%">User Type</th> */}
                  <th width="12%">Employee ID</th>
                  <th width="13%">Name</th>
                  <th width="15%">Email</th>
                  <th width="15%">Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentAdmins.map((admin, index) =>
                  admin.users.length > 0 ? (
                    admin.users.map((user, userIndex) => (
                      <tr key={`${index}-${userIndex}`}>
                        {userIndex === 0 && (
                          <>
                            <td rowSpan={admin.users.length} style={{ fontWeight: 600, color: 'var(--c-navy)' }}>
                              {admin.name}
                            </td>
                            <td rowSpan={admin.users.length}>
                              <span style={{ display: 'block', marginBottom: 6 }}>{admin.address}</span>
                              <span
                                id="edit"
                                title="Edit address"
                                onClick={() => { setSelectedPU(admin); setShowAddress(true); }}
                              >
                                <FontAwesomeIcon icon={faEdit} />
                              </span>
                            </td>
                          </>
                        )}
                        <td>{user[1]}</td>
                        <td style={{ fontWeight: 500 }}>{user[2]}</td>
                        <td style={{ color: 'var(--c-muted)' }}>{user[3]}</td>
                        <td>
                          <button className="edit-button" onClick={() => handleEditUser(user, admin)}>
                            Edit
                          </button>
                          <button
                            className="delete-button"
                            onClick={() => { setSelectedUser(user); setShowDeleteModal(true); }}
                          >
                            Delete
                          </button>

                          <button
                            onClick={() => handleResetDeviceClick(user)}   // ← changed
                            disabled={!user[4]}
                            title={user[4] ? "Reset this user's registered device" : "No device registered yet"}
                            style={{
                              marginLeft: '6px',
                              padding: '4px 10px',
                              fontSize: '0.78rem',
                              fontWeight: 600,
                              borderRadius: '6px',
                              border: '1px solid',
                              cursor: user[4] ? 'pointer' : 'not-allowed',
                              background: user[4] ? '#fef2f2' : '#f5f5f5',
                              color: user[4] ? '#b91c1c' : '#aaa',
                              borderColor: user[4] ? '#fca5a5' : '#ddd',
                              transition: 'all 0.2s',
                            }}
                          >
                            {user[4] ? 'Reset Device' : 'No Device'}
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr key={`${index}-empty`}>
                      <td style={{ fontWeight: 600, color: 'var(--c-navy)' }}>{admin.name}</td>
                      <td rowSpan={admin.users.length}>
                        <span style={{ display: 'block', marginBottom: 6 }}>{admin.address}</span>
                        <span
                          id="edit"
                          title="Edit address"
                          onClick={() => { setSelectedPU(admin); setShowAddress(true); }}
                        >
                          <FontAwesomeIcon icon={faEdit} />
                        </span>
                      </td>
                      <td colSpan={5} style={{ color: 'var(--c-muted)', fontStyle: 'italic' }}>
                        No users assigned
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>

            {/* ── Pagination ── */}
            <div className="pagination-controls">
              <button onClick={handlePreviousPage} disabled={currentPage === 1}>
                ← Previous
              </button>
              <span>Page {currentPage} of {totalPages}</span>
              <button onClick={handleNextPage} disabled={currentPage === totalPages}>
                Next →
              </button>
            </div>
          </div>

          {/* ── Bottom Action Buttons ── */}
          <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
            <button onClick={() => navigate('/create-production')} className="create-admin-button">
              + Add Production Unit
            </button>
            <button onClick={() => navigate('/create-admin')} className="create-admin-button">
              + Add Users
            </button>
          </div>
        </div>
      </div>

      {/* ── Address Edit Modal ── */}
      {showAddress && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Edit Address</h2>
            <div className="mb-3">
              <label>Address</label>
              <textarea onChange={handleAddressChange} defaultValue={selectedPU.address} />
            </div>
            <div className="action-buttons">
              <button className="no" onClick={() => setShowAddress(false)}>
                Cancel
              </button>
              <button className="yes" onClick={updateAddress}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Loading Overlay ── */}
      <div className="loading" id="loading">
        <GridLoader color="var(--c-navy)" loading={true} size={18} />
      </div>
    </div>
  );
}

export default Admin;